import { render } from "./RequestForm.vue?vue&type=template&id=784e9722"
import script from "./RequestForm.vue?vue&type=script&lang=js"
export * from "./RequestForm.vue?vue&type=script&lang=js"
script.render = render

export default script